<div class="columns-1 sm:columns-2 lg:columns-3 gap-4 p-1 [column-fill:_balance]">

  <ng-container *ngFor="let card of cards; trackBy: trackByCardId">
    <div
      class="mb-4 break-inside-avoid border-2 border-primary rounded-md bg-white dark:bg-gray-800"
      *ngIf="calculateItemCount(card._id) > 0">
      <div
        class="h-7 font-bold border-b border-[var(--borderColor)] text-black dark:text-white bg-primary flex items-center justify-between relative px-1"
        [style.background-color]="getCardColor(card.Color)">
        <button
          *ngIf="isSelectMode"
          type="button"
          class="category-select-toggle"
          [ngClass]="{ 'category-select-toggle--active': areAllNotesSelectedForCard(card._id) }"
          (click)="toggleSelectAllForCard(card._id, $event)">
          <i class="pi" [ngClass]="areAllNotesSelectedForCard(card._id) ? 'pi-check-square' : 'pi-clone'"></i>
        </button>

        <div
          class="category-card-title flex-1 max-w-full cursor-pointer"
          [class.pl-2]="!isSelectMode"
          [class.pl-7]="isSelectMode"
          [class.pr-24]="card.Type === 'tag'"
          [class.pr-8]="card.Type !== 'tag'"
          [title]="card.Title"
          (click)="clickCardHeader(card)">
          <span class="category-card-title__text">{{ card.Title }}</span>
          <span class="category-card-count" [attr.aria-label]="calculateItemCount(card._id) + ' active items'">
            {{ calculateItemCount(card._id) }}
          </span>
        </div>

        <button
          type="button"
          class="category-expand-toggle"
          [attr.aria-label]="card.isExpanded ? 'Collapse card' : 'Expand card'"
          [attr.aria-expanded]="card.isExpanded"
          (click)="toggleCardExpanded(card, $event)">
          <span class="material-symbols-outlined text-base transition-transform duration-200"
                [style.transform]="card.isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'">
            expand_more
          </span>
        </button>

        <button
          *ngIf="card.Type === 'tag'"
          type="button"
          class="category-add-button"
          aria-label="Create note with tag"
          (click)="createNoteForTag(card._id, $event)">
          +
        </button>
      </div>

      <div class="max-h-72 overflow-y-auto transition-all duration-300 ease-in-out" *ngIf="card.isExpanded" [@slideDown]>
        <table class="w-full">
          <tbody>
            <tr
              class="h-8 hover:bg-primary-400 cursor-pointer bg-primary-100"
              *ngFor="let note of getNotesForCard(card._id); trackBy: trackByNoteId"
              [ngClass]="{
                'bg-[var(--project5Color)]': note.ProjectName === 'Work',
                'bg-[var(--project1Color)]': note.ProjectName === 'NotesApp',
                'bg-[var(--project2Color)]': note.ProjectName === 'Vivi/Olivia',
                'bg-[var(--project3Color)]': note.ProjectName === 'Shopping',
                'font-bold': isEmphasizedStatus(note.Status),
                'italic text-[var(--textColorFaded)]':
                  isMutedStatus(note.Status),
                'ring-2 ring-primary-600': isNoteSelected(note._id),
                'select-mode-row': isSelectMode
              }">
              <td
                class="px-2 border border-[var(--borderColor)] w-7 max-w-7"
                [ngClass]="{
                  '!bg-orange-300': note.syncStatus === 'updated',
                  '!bg-red-600': note.syncStatus === 'new',
                  '!line-through text-red-600': note.syncStatus === 'deleted'
                }">
                <a *ngIf="!isSelectMode; else selectMode" id="EditLink" [routerLink]="['/edit', note?._id]" (click)="$event.stopPropagation()">
                  <i class="pi pi-pen-to-square"></i>
                </a>

                <ng-template #selectMode>
                  <button
                    type="button"
                    class="flex items-center justify-center rounded border border-[var(--borderColor)] bg-white text-primary shadow-sm transition hover:-translate-y-0.5 hover:shadow"
                    aria-label="Toggle selection"
                    (click)="toggleSelection(note, $event)">
                    <i
                      class="pi"
                      [ngClass]="{
                        'pi-check-square text-primary-600': isNoteSelected(note?._id),
                        'pi-square text-gray-400': !isNoteSelected(note?._id)
                      }"></i>
                  </button>
                </ng-template>
              </td>
              <td
                class="w-96 whitespace-normal px-2 border border-[var(--borderColor)]"
                (click)="clickRow(note)"
                [ngClass]="{
                  '!line-through text-red-600': note.Status === 'Deleted' || note.syncStatus === 'deleted',
                  '!text-red-500': note.syncStatus !== 'synced' && note.syncStatus !== 'deleted'
                }">
                {{ this.getNoteYearPrefix(note) }}
                {{ note.Title | noteDisplayTitle: note.DescriptionHtml }}
                {{ this.getAttachmentFlag(note) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

</div>
